import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const NotFound = () => (
  <main className="container-x flex min-h-[80vh] flex-col items-start justify-center pt-[76px]" data-testid="not-found-page">
    <p className="eyebrow">404</p>
    <h1 className="display mt-6 text-[clamp(4rem,12vw,12rem)] uppercase leading-[0.82] tracking-wide">
      Lost <span className="text-stroke">ink</span>
    </h1>
    <p className="mt-6 max-w-md text-muted-foreground">The page you're looking for doesn't exist. Head back to the studio.</p>
    <Button asChild className="mt-10 h-12 rounded-none px-7 text-[11px] font-semibold uppercase tracking-[0.2em]">
      <Link to="/">
        <ArrowLeft className="mr-2 h-4 w-4" /> Return Home
      </Link>
    </Button>
  </main>
);

export default NotFound;
